export const LATERAL_STATUS_OPTIONS = [
  { value: "draft", label: "Draft" },
  { value: "applied", label: "Applied" },
  { value: "ai_rejected", label: "AI Rejected" },
  { value: "shortlisted", label: "Shortlisted" },
  { value: "interview_scheduled", label: "Interview Scheduled" },
  { value: "hired", label: "Hired" },
  { value: "on_hold", label: "On Hold" },
  { value: "rejected", label: "Rejected" },
] as const;

export const LATERAL_STATUS_COLORS: Record<string, string> = {
  draft: "bg-gray-100 text-gray-500",
  applied: "bg-blue-100 text-blue-700",
  ai_rejected: "bg-red-50 text-red-600",
  shortlisted: "bg-green-100 text-green-700",
  interview_scheduled: "bg-purple-100 text-purple-700",
  hired: "bg-emerald-100 text-emerald-700",
  on_hold: "bg-yellow-100 text-yellow-700",
  rejected: "bg-red-100 text-red-700",
};

export const LATERAL_KANBAN_COLUMNS = [
  { id: "applied", title: "Applied" },
  { id: "ai_rejected", title: "AI Rejected" },
  { id: "shortlisted", title: "Shortlisted" },
  { id: "interview_scheduled", title: "Interview Scheduled" },
  { id: "hired", title: "Hired" },
  { id: "on_hold", title: "On Hold" },
  { id: "rejected", title: "Rejected" },
];

export function getLateralStatusLabel(status: string) {
  return LATERAL_STATUS_OPTIONS.find((s) => s.value === status)?.label ?? status;
}
